import axios from 'axios'
import i18n from 'i18next'

export const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL ?? ''}`,
  withCredentials: true,
  timeout: 30000,
})

apiClient.interceptors.request.use(
  (config) => {
    const lang = i18n.language
    if (lang) {
      config.headers['Accept-Language'] = lang
    }
    return config
  },
  (error) => Promise.reject(error)
)

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('[API Client] Error:', error.response?.data)
    throw error
  }
)
